const messageToolCalls = message => (
  Array.isArray(message && message.tool_calls)
    ? message.tool_calls.filter(Boolean)
    : []
)

const renderedToolCallIds = events => {
  const ids = []
  for (const event of events || []) {
    const message = event && event.message
    if (!message) continue
    if (message.tool_call_id) ids.push(message.tool_call_id)
    for (const call of messageToolCalls(message)) ids.push(call.id)
  }
  return Array.from(new Set(ids.filter(Boolean)))
}

const toolCallNavigationTarget = ({ events, toolCallId }) => {
  if (!toolCallId) return null
  const direct = (events || []).find(event => (
    event && event.message && (
      event.message.tool_call_id === toolCallId ||
      messageToolCalls(event.message).some(call => call.id === toolCallId)
    )
  ))
  if (!direct) return null
  const toolUseIds = renderedToolCallIds(events)
  if (!toolUseIds.length) return null
  const renderedToolCallId = toolUseIds.includes(toolCallId)
    ? toolCallId
    : toolUseIds[0]
  return {
    event: direct,
    unitIndex: 0,
    toolUseGroupId: toolUseIds[0],
    toolUseIds,
    toolUseIndex: Math.max(0, toolUseIds.indexOf(renderedToolCallId)),
    renderedToolCallId,
    toolCallId
  }
}

module.exports = {
  renderedToolCallIds,
  toolCallNavigationTarget
}
